import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HomeButtonSection from "../components/HomeButtonSection";

interface LayoutProps {
  children: React.ReactNode;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export default function Layout({ 
  children,
  searchQuery,
  setSearchQuery
}: LayoutProps) {
  return (
    <div className="min-h-screen bg-[#030712] text-slate-100 antialiased font-sans selection:bg-cyan-500/20 selection:text-cyan-300 relative flex flex-col justify-between">
      
      {/* Background Celestial Glowing Nodes / Constellation Grid Effect */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
        {/* Soft Background Radial Blurs */}
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-emerald-500/5 blur-[120px]" />
        <div className="absolute top-[20%] right-[-10%] w-[60%] h-[60%] rounded-full bg-cyan-500/5 blur-[150px]" />
        <div className="absolute bottom-[-10%] left-[20%] w-[50%] h-[50%] rounded-full bg-indigo-500/5 blur-[120px]" />

        {/* Floating Constellation Glowing Points */}
        <div className="absolute top-[15%] left-[16%] w-2 h-2 rounded-full bg-cyan-400 opacity-60 animate-pulse glow-cyan" />
        <div className="absolute top-[8%] left-[39%] w-1.5 h-1.5 rounded-full bg-purple-500 opacity-40 animate-pulse" />
        <div className="absolute top-[35%] left-[43%] w-1.5 h-1.5 rounded-full bg-emerald-500 opacity-50 animate-pulse" />
        <div className="absolute top-[60%] left-[9%] w-2 h-2 rounded-full bg-emerald-400 opacity-60" />
        <div className="absolute top-[25%] right-[35%] w-1.5 h-1.5 rounded-full bg-purple-600 opacity-40" />
        <div className="absolute top-[63%] right-[31%] w-2 h-2 rounded-full bg-cyan-400 opacity-60 glow-cyan" />
        <div className="absolute top-[63%] right-[17%] w-1.5 h-1.5 rounded-full bg-purple-500 opacity-50" />
        <div className="absolute bottom-[20%] left-[43%] w-1.5 h-1.5 rounded-full bg-purple-500/60" />
        <div className="absolute bottom-[25%] right-[56%] w-1.5 h-1.5 rounded-full bg-yellow-500/40" />
        <div className="absolute bottom-[35%] right-[2%] w-1.5 h-1.5 rounded-full bg-purple-500/40" />

        {/* Constellation Connector Lines */}
        <svg className="absolute inset-0 w-full h-full opacity-10" xmlns="http://www.w3.org/2000/svg">
          <line x1="16%" y1="15%" x2="39%" y2="8%" stroke="#06b6d4" strokeWidth="1" strokeDasharray="3 3" />
          <line x1="39%" y1="8%" x2="43%" y2="35%" stroke="#8b5cf6" strokeWidth="1" strokeDasharray="3 3" />
          <line x1="9%" y1="60%" x2="16%" y2="15%" stroke="#10b981" strokeWidth="1" strokeDasharray="3 3" />
          <line x1="63%" y1="63%" x2="83%" y2="63%" stroke="#06b6d4" strokeWidth="1" strokeDasharray="3 3" />
          <line x1="63%" y1="63%" x2="69%" y2="25%" stroke="#8b5cf6" strokeWidth="1" strokeDasharray="3 3" />
        </svg>
      </div>

      <div className="relative z-10 flex flex-col min-h-screen justify-between">
        
        {/* Nav Header */}
        <Header
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />

        {/* Main interactive slot with proper padding and layout boundaries */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex-grow w-full relative">
          {children}
          <HomeButtonSection />
        </main>

        {/* Shared Footer block */}
        <Footer />
      </div>

    </div>
  );
}
